import { useScope } from "@state/scopeContext.lib";
import { useCallback } from "react";

export function useSwitchToPersonalView() {
    const { clear } = useScope();

    return useCallback(() => {
        clear();
    }, [clear]);
}
